import type { AirCfarPriceQuoteDataV2 } from "@b2bportal/air-cfar-api";
import type {
  LodgingCfarPriceQuoteDataV1,
  PriceQuoteData as HtsLodgingCfarPriceQuoteData,
} from "@b2bportal/lodging-cfar-api";

import { type Prices, Product } from "@b2bportal/purchase-api";
import { createSelector } from "@reduxjs/toolkit";
import { getQuoteBreakdown } from "../Cart/CartQuote/selectors";

export type CartQuoteBreakdownProducts = {
  [Product.AirCfar]?: {
    totalPremiumAmount: Prices;
  };
  [Product.HtsAirCfar]?: {
    totalPremiumAmount: Prices;
  };
  [Product.LodgingCfar]?: {
    totalPremiumAmount: Prices;
  };
  [Product.HtsLodgingCfar]?: {
    totalPremiumAmount: Prices;
  };
};

export const getCartQuoteBreakdownProducts = createSelector(
  getQuoteBreakdown,
  (quoteBreakdown) =>
    quoteBreakdown?.products.reduce((acc, { product }) => {
      if (product.type === Product.LodgingCfar) {
        acc[Product.LodgingCfar] = product.value as LodgingCfarPriceQuoteDataV1;
      }

      if (product.type === Product.HtsLodgingCfar) {
        acc[Product.HtsLodgingCfar] =
          product.value as HtsLodgingCfarPriceQuoteData;
      }

      if (product.type === Product.AirCfar) {
        acc[Product.AirCfar] = product.value as AirCfarPriceQuoteDataV2;
      }

      if (product.type === Product.HtsAirCfar) {
        acc[Product.HtsAirCfar] = product.value as AirCfarPriceQuoteDataV2;
      }
      return acc;
    }, {} as CartQuoteBreakdownProducts) ?? {}
);
